import Shared from "emun.cart/cart.controller";
import resolve from "ioc/resolve";
import templateUrl from "emun.cart/usaepay/cart-creditcard-usaepay.htm";
import AutoQuery from "servicestack/auto-query/auto-query.es6";
import modals from "webmodals/modals";
import ServiceBus from "servicestack/service-bus";
import cartConfig from "emun.cart/cart.config";

export class CartCreditCardUsaepayController extends Shared {
	constructor($cart, $sce) {
		super($cart, $sce);
		let $rootScope = resolve("$rootScope");
		let $stateParams = resolve("$stateParams");
		let $ctrl = this;

			// Instantiate Client with Public API Key
			let client = new usaepay.Client('jl9uF53Vi7i7z431uigd6HIfx3inYiU86v3S6a5HR7');
			// Instantiate Payment Card Entry
			let paymentCard = client.createPaymentCardEntry();

			$ctrl.paymentMethod = {};
			if ($ctrl.retailer) {
				$ctrl.paymentMethod = {
					name: $ctrl.retailer.companyName,
					address: $ctrl.retailer.address,
					address2: $ctrl.retailer.address2,
					city: $ctrl.retailer.city,
					state: $ctrl.retailer.state,
					zip: $ctrl.retailer.zip,
					retailerId: $ctrl.retailer.id,
					country: $ctrl.retailer.country.toUpperCase() == "UNITED STATES" ? "US" : $ctrl.retailer.country.toUpperCase() == "CANADA" ? "CA" : $ctrl.retailer.country,
				};
			} else if ($stateParams.cartId) {
				$cart.load($stateParams.cartId);
				$ctrl.paymentMethod = {
					name: $ctrl.$cart.buyer || $ctrl.$cart.billingLocation.companyName,
					address: $ctrl.$cart.purchaser.address,
					address2: $ctrl.$cart.purchaser.address2,
					city: $ctrl.$cart.purchaser.city,
					state: $ctrl.$cart.purchaser.state,
					zip: $ctrl.$cart.purchaser.zip,
					country: $ctrl.$cart.purchaser.country.toUpperCase() == "UNITED STATES" ? "US" : $ctrl.$cart.purchaser.country.toUpperCase() == "CANADA" ? "CA" : $ctrl.$cart.purchaser.country,
				};
			} 
			$ctrl.bus = new ServiceBus;
			$ctrl.cartConfig = cartConfig;
			let retailerId = $ctrl.retailer ? $ctrl.retailer.id : $ctrl.$cart.retailerId;

			const paymentCardConfig = {
				//add config here
			}
			paymentCard.generateHTML(paymentCardConfig);
			paymentCard.addHTML('paymentCardContainer');


			let form = document.getElementById('paymentForm');
			form.addEventListener('submit', event => {
				event.preventDefault();
				if ($ctrl.$cart.paymentMethod.name) {
					// tokenize payment data
					console.debug("BL*** calling client.getPaymentKey", paymentCard);
					client.getPaymentKey(paymentCard).then(result => {
						console.debug("BL*** getPaymentKey result", result);
						if (result.error) {
							handleError(result.error.message);
						} else {
							$ctrl.handlePaymentKey(result.key);
						}
					}).catch( err => {
						console.debug("BL*** exception in getPaymentKey", err);
						$ctrl.handleError(err.message);
					});
				} else {
					modals.alert("Please enter Name on Card");
				}
			});	
			
			// add an error event listener to the paymentCard element
			paymentCard.addEventListener('error', err => {
				err = JSON.parse(err);
				console.debug("BL*** paymentCard.addEventListener error", err);
				console.error(err); // for debug when developing
				// error code 0 means there was no issue and you can clear your error. 
				if (err.code === '0') {
					$ctrl.clearError();
				} else {
					$ctrl.handleError(err);
				}
			});
		
	}

	handlePaymentKey(paymentKey) {
		// Insert the payment key into the form so it gets submitted to the server
		const $ctrl = this;
		let $rootScope = resolve("$rootScope");
		$ctrl.bus.send("USAePay/GetPaymentDetails", {
			CartId: $ctrl.$cart.id,
			PaymentKey: paymentKey,
			NameOnCard: $ctrl.$cart.paymentMethod.name
		}).then(function(res) {
			console.debug("BL*** res", res);
			if (res.data.result == "Approved") {
				$ctrl.$cart.load();
			} else {
				modals.alert("Credit card transaction failure: " + res.data.result);
			}
		});
	}


	handleError(err) {
		var errorContainerEl = document.getElementById('paymentCardErrorContainer');
		errorContainerEl.textContent = err.message + " - " + err.reason;
		errorContainerEl.classList.remove('hidden');
	}

	clearError() {
		var errorContainerEl = document.getElementById('paymentCardErrorContainer');
		errorContainerEl.textContent = '';
		errorContainerEl.classList.add('hidden');
	}

	initNmi() {
		let $ctrl = this;
	}
	toggleSameAsCorporate() {
		let $ctrl = this;
		if ($ctrl.sameAsCorporate) {
			$ctrl.paymentMethod.address =
				$ctrl.$cart.purchaser.address || $ctrl.$cart.billingLocation.address;
			$ctrl.paymentMethod.address2 =
				$ctrl.$cart.purchaser.address2 || $ctrl.$cart.billingLocation.address2;
			$ctrl.paymentMethod.city =
				$ctrl.$cart.purchaser.city || $ctrl.$cart.billingLocation.city;
			$ctrl.paymentMethod.state =
				$ctrl.$cart.purchaser.state || $ctrl.$cart.billingLocation.state;
			$ctrl.paymentMethod.zip =
				$ctrl.$cart.purchaser.zip || $ctrl.$cart.billingLocation.zip;
			$ctrl.paymentMethod.country =
				$ctrl.$cart.purchaser.country || $ctrl.$cart.billingLocation.country;
		}
	}
}

export default {
	bindings: {
		retailerId: "@",
		retailer: "<",
		returnUri: "@"
	},
	controller: CartCreditCardUsaepayController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};
